import { IApplicationState } from '../types';

export const getOpenModalName = (state: IApplicationState): string =>
  state.modals.name;

export const getModalProps = (state: IApplicationState) => state.modals.props;
export const getModalLoading = (state: IApplicationState) =>
  state.modals.loading;
